import { useAdminMessageNotifications } from 'hooks/useAdminMessageNotifications';

/** Mount once for authenticated users to toast new admin broadcasts app-wide. */
const AdminMessageNotificationListener = () => {
  useAdminMessageNotifications();
  return null;
};

export default AdminMessageNotificationListener;
